import { usePointsTokensQuery } from "shared/api/use-points-tokens-query";
import BentoLogo3d from "shared/assets/bento-logo-3d.svg?react";

import { Section } from "../section";
import bg from "./bg.svg";
import { Header } from "./header";
import { ReferralPanel } from "./referral-panel";
import { Row } from "./row";

export const PoolsSection = () => {
  const pointsTokensQuery = usePointsTokensQuery();

  return (
    <div
      className="relative w-full bg-top bg-no-repeat"
      style={{
        backgroundImage: `url(${bg})`,
        backgroundSize: "cover",
      }}
    >
      <Section className="flex-col items-center md:flex-col">
        <Section.Title>
          Maximise Your Rewards <br /> With{" "}
          <span className="relative mx-2 inline-flex items-baseline justify-end gap-2">
            <BentoLogo3d className="size-9 md:size-13.5" /> Bento
          </span>
          Ecosystem
        </Section.Title>

        <Section.Description>
          Unlock even greater rewards by using bentoUSD and bentoUSD+ across
          partner DeFi protocols in the Bento ecosystem.
        </Section.Description>

        <ReferralPanel className="mt-24.5 mb-8" />

        <Header className="mb-3.5" />
        <div className="flex w-full flex-col gap-1.5 overflow-hidden rounded-[20px]">
          {pointsTokensQuery.data?.map((token) => {
            return <Row key={token.symbol} token={token} />;
          })}
        </div>
      </Section>
    </div>
  );
};
